import { useToggleState } from "@react-stately/toggle";
import _spectrumIconsUiCrossSmall from "@spectrum-icons/ui/CrossSmall";
import { useProviderProps } from "@react-spectrum/provider";
import { useHover } from "@react-aria/interactions";
import { useButton, useToggleButton } from "@react-aria/button";
import { Text } from "@react-spectrum/text";
import _react from "react";
import { mergeProps } from "@react-aria/utils";
import { FocusRing } from "@react-aria/focus";
import { classNames, SlotProvider, useFocusableRef, useSlotProps, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/button/vars.css
var $a0b8eb4b46824fd288195a4db8814b$exports = {};
$a0b8eb4b46824fd288195a4db8814b$exports = {
  "spectrum-Button": "_spectrum-Button_7a745",
  "spectrum-ActionButton": "_spectrum-ActionButton_7a745",
  "spectrum-LogicButton": "_spectrum-LogicButton_7a745",
  "spectrum-FieldButton": "_spectrum-FieldButton_7a745",
  "spectrum-ClearButton": "_spectrum-ClearButton_7a745",
  "focus-ring": "_focus-ring_7a745",
  "spectrum-Icon": "_spectrum-Icon_7a745",
  "spectrum-ActionButton--emphasized": "_spectrum-ActionButton--emphasized_7a745",
  "spectrum-ActionButton--staticColor": "_spectrum-ActionButton--staticColor_7a745",
  "is-hovered": "_is-hovered_7a745",
  "spectrum-Button-label": "_spectrum-Button-label_7a745",
  "spectrum-ActionButton-label": "_spectrum-ActionButton-label_7a745",
  "spectrum-ActionButton-hold": "_spectrum-ActionButton-hold_7a745",
  "spectrum-ActionButton--quiet": "_spectrum-ActionButton--quiet_7a745",
  "is-disabled": "_is-disabled_7a745",
  "is-open": "_is-open_7a745",
  "spectrum-FieldButton--quiet": "_spectrum-FieldButton--quiet_7a745",
  "spectrum-ClearButton--overBackground": "_spectrum-ClearButton--overBackground_7a745",
  "spectrum-ClearButton--small": "_spectrum-ClearButton--small_7a745",
  "is-focused": "_is-focused_7a745",
  "is-active": "_is-active_7a745",
  "spectrum-Button--cta": "_spectrum-Button--cta_7a745",
  "spectrum-Button--primary": "_spectrum-Button--primary_7a745",
  "spectrum-Button--secondary": "_spectrum-Button--secondary_7a745",
  "spectrum-Button--warning": "_spectrum-Button--warning_7a745",
  "spectrum-Button--overBackground": "_spectrum-Button--overBackground_7a745",
  "spectrum-Button--quiet": "_spectrum-Button--quiet_7a745",
  "is-selected": "_is-selected_7a745",
  "spectrum-ActionButton--staticWhite": "_spectrum-ActionButton--staticWhite_7a745",
  "spectrum-ActionButton--staticBlack": "_spectrum-ActionButton--staticBlack_7a745",
  "spectrum-LogicButton--and": "_spectrum-LogicButton--and_7a745",
  "spectrum-LogicButton--or": "_spectrum-LogicButton--or_7a745",
  "is-placeholder": "_is-placeholder_7a745",
  "spectrum-FieldButton--invalid": "_spectrum-FieldButton--invalid_7a745"
};
// todo: CSS hasn't caught up yet, map
let $e7cce67cb180bb656d80b00f5a768a9$var$VARIANT_MAPPING = {
  negative: 'warning'
};
var $a0b8eb4b46824fd288195a4db8814b$$interop$default = $parcel$interopDefault($a0b8eb4b46824fd288195a4db8814b$exports);

function $e7cce67cb180bb656d80b00f5a768a9$var$Button(props, ref) {
  props = useProviderProps(props);
  props = useSlotProps(props, 'button');

  let {
    elementType: ElementType = 'button',
    children,
    variant,
    isQuiet,
    isDisabled,
    autoFocus
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["elementType", "children", "variant", "isQuiet", "isDisabled", "autoFocus"]);

  let domRef = useFocusableRef(ref);
  let {
    buttonProps,
    isPressed
  } = useButton(props, domRef);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let {
    styleProps
  } = useStyleProps(otherProps);
  let buttonVariant = variant;

  if ($e7cce67cb180bb656d80b00f5a768a9$var$VARIANT_MAPPING[variant]) {
    buttonVariant = $e7cce67cb180bb656d80b00f5a768a9$var$VARIANT_MAPPING[variant];
  }

  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement(ElementType, _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(buttonProps, hoverProps), {
    ref: domRef,
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Button', "spectrum-Button--" + buttonVariant, {
      'spectrum-Button--quiet': isQuiet,
      'is-disabled': isDisabled,
      'is-active': isPressed,
      'is-hovered': isHovered
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      icon: {
        size: 'S',
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Icon')
      },
      text: {
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Button-label')
      }
    }
  }, typeof children === 'string' ? /*#__PURE__*/_react.createElement(Text, null, children) : children)));
}
/**
 * Buttons allow users to perform an action or to navigate to another page.
 * They have multiple styles for various needs, and are ideal for calling attention to
 * where a user needs to do something in order to move forward in a flow.
 */


export let Button = /*#__PURE__*/_react.forwardRef($e7cce67cb180bb656d80b00f5a768a9$var$Button);

function $bc80af2826ac4208742b91a4749726d$var$ActionButton(props, ref) {
  props = useProviderProps(props);
  props = useSlotProps(props, 'actionButton');

  let {
    isQuiet,
    isDisabled,
    staticColor,
    children,
    autoFocus
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["isQuiet", "isDisabled", "staticColor", "children", "autoFocus"]);

  let domRef = useFocusableRef(ref);
  let {
    buttonProps,
    isPressed
  } = useButton(props, domRef);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let {
    styleProps
  } = useStyleProps(otherProps);

  let isTextOnly = _react.Children.toArray(props.children).every(c => ! /*#__PURE__*/_react.isValidElement(c));

  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("button", _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(buttonProps, hoverProps), {
    ref: domRef,
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-ActionButton', {
      'spectrum-ActionButton--quiet': isQuiet,
      'spectrum-ActionButton--staticColor': !!staticColor,
      'spectrum-ActionButton--staticWhite': staticColor === 'white',
      'spectrum-ActionButton--staticBlack': staticColor === 'black',
      'is-active': isPressed,
      'is-disabled': isDisabled,
      'is-hovered': isHovered
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      icon: {
        size: 'S',
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Icon')
      },
      text: {
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-ActionButton-label')
      }
    }
  }, typeof children === 'string' || isTextOnly ? /*#__PURE__*/_react.createElement(Text, null, children) : children)));
}
/**
 * ActionButtons allow users to perform an action.
 * They’re used for similar, task-based options within a workflow, and are ideal for interfaces where buttons aren’t meant to draw a lot of attention.
 */


export let ActionButton = /*#__PURE__*/_react.forwardRef($bc80af2826ac4208742b91a4749726d$var$ActionButton);

// @private
function $c625b8542216f3af615209ec995fde6$var$FieldButton(props, ref) {
  props = useSlotProps(props, 'button');

  let {
    isQuiet,
    isDisabled,
    validationState,
    children,
    autoFocus,
    isActive,
    focusRingClass
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["isQuiet", "isDisabled", "validationState", "children", "autoFocus", "isActive", "focusRingClass"]);

  let domRef = useFocusableRef(ref);
  let {
    buttonProps,
    isPressed
  } = useButton(props, domRef);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let {
    styleProps
  } = useStyleProps(otherProps);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'focus-ring', focusRingClass),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("button", _babelRuntimeHelpersEsmExtends({}, mergeProps(buttonProps, hoverProps), {
    ref: domRef,
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-FieldButton', {
      'spectrum-FieldButton--quiet': isQuiet,
      'is-active': isActive || isPressed,
      'is-disabled': isDisabled,
      'spectrum-FieldButton--invalid': validationState === 'invalid',
      'is-hovered': isHovered
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      icon: {
        size: 'S',
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Icon')
      }
    }
  }, children)));
}

export let FieldButton = /*#__PURE__*/_react.forwardRef($c625b8542216f3af615209ec995fde6$var$FieldButton);

function $f75e54f949cd322517f94110447328bc$var$LogicButton(props, ref) {
  props = useProviderProps(props);

  let {
    variant,
    children,
    isDisabled,
    autoFocus
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["variant", "children", "isDisabled", "autoFocus"]);

  let domRef = useFocusableRef(ref);
  let {
    buttonProps,
    isPressed
  } = useButton(props, domRef);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let {
    styleProps
  } = useStyleProps(otherProps);
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("button", _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(buttonProps, hoverProps), {
    ref: domRef,
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-LogicButton', {
      ["spectrum-LogicButton--" + variant]: variant,
      'is-disabled': isDisabled,
      'is-active': isPressed,
      'is-hovered': isHovered
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement("span", {
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Button-label')
  }, children)));
}
/**
 * A LogicButton displays an operator within a boolean logic sequence.
 */


export let LogicButton = /*#__PURE__*/_react.forwardRef($f75e54f949cd322517f94110447328bc$var$LogicButton);

function $d84be0be8cc370fcf4ad9b30ea651284$var$ClearButton(props, ref) {
  let {
    children = /*#__PURE__*/_react.createElement(_spectrumIconsUiCrossSmall, {
      UNSAFE_className: $a0b8eb4b46824fd288195a4db8814b$$interop$default['spectrum-Icon']
    }),
    focusClassName,
    variant,
    autoFocus,
    isDisabled,
    preventFocus,
    elementType = preventFocus ? 'div' : 'button'
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "focusClassName", "variant", "autoFocus", "isDisabled", "preventFocus", "elementType"]);

  let domRef = useFocusableRef(ref);
  let {
    buttonProps,
    isPressed
  } = useButton(_babelRuntimeHelpersEsmExtends({}, props, {
    elementType
  }), domRef);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let {
    styleProps
  } = useStyleProps(otherProps); // For cases like the clear button in a search field, remove the tabIndex so
  // iOS 14 with VoiceOver doesn't focus the button and hide the keyboard when
  // moving the cursor over the clear button.

  if (preventFocus) {
    delete buttonProps.tabIndex;
  }

  let ElementType = elementType;
  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'focus-ring', focusClassName),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement(ElementType, _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(buttonProps, hoverProps), {
    ref: domRef,
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-ClearButton', {
      ["spectrum-ClearButton--" + variant]: variant,
      'is-disabled': isDisabled,
      'is-active': isPressed,
      'is-hovered': isHovered
    }, styleProps.className)
  }), children));
}

export let ClearButton = /*#__PURE__*/_react.forwardRef($d84be0be8cc370fcf4ad9b30ea651284$var$ClearButton);

function $ee41bfa1892cb064198e19baae3426a$var$ToggleButton(props, ref) {
  props = useProviderProps(props);

  let {
    isQuiet,
    isDisabled,
    isEmphasized,
    staticColor,
    children,
    autoFocus
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["isQuiet", "isDisabled", "isEmphasized", "staticColor", "children", "autoFocus"]);

  let domRef = useFocusableRef(ref);
  let state = useToggleState(props);
  let {
    buttonProps,
    isPressed
  } = useToggleButton(props, state, domRef);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let {
    styleProps
  } = useStyleProps(otherProps);

  let isTextOnly = _react.Children.toArray(props.children).every(c => ! /*#__PURE__*/_react.isValidElement(c));

  return /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("button", _babelRuntimeHelpersEsmExtends({}, styleProps, mergeProps(buttonProps, hoverProps), {
    ref: domRef,
    className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-ActionButton', {
      'spectrum-ActionButton--quiet': isQuiet,
      'spectrum-ActionButton--emphasized': isEmphasized,
      'spectrum-ActionButton--staticColor': !!staticColor,
      'spectrum-ActionButton--staticWhite': staticColor === 'white',
      'spectrum-ActionButton--staticBlack': staticColor === 'black',
      'is-active': isPressed,
      'is-disabled': isDisabled,
      'is-hovered': isHovered,
      'is-selected': state.isSelected
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement(SlotProvider, {
    slots: {
      icon: {
        size: 'S',
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-Icon')
      },
      text: {
        UNSAFE_className: classNames($a0b8eb4b46824fd288195a4db8814b$$interop$default, 'spectrum-ActionButton-label')
      }
    }
  }, typeof children === 'string' || isTextOnly ? /*#__PURE__*/_react.createElement(Text, null, children) : children)));
}
/**
 * ToggleButtons allow users to toggle a selection on or off, for example
 * switching between two states or modes.
 */


export let ToggleButton = /*#__PURE__*/_react.forwardRef($ee41bfa1892cb064198e19baae3426a$var$ToggleButton);
//# sourceMappingURL=module.js.map
